export function applyPolyfills() {
    if (typeof Promise.allSettled !== 'function') {
        /**
         * Polyfill for Promise.allSettled
         * @param promises - An array of promises
         * @returns A promise that resolves when all of the given promises have either resolved or rejected
         */
        Promise.allSettled = function <T>(
            promises: Promise<T>[]
        ): Promise<Array<
            | { status: 'fulfilled'; value: T }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            | { status: 'rejected'; reason: any }
        >> {
        return Promise.all(
            promises.map(p =>
            p
                .then((value): { status: 'fulfilled'; value: T } => ({ status: 'fulfilled', value }))
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .catch((reason): { status: 'rejected'; reason: any } => ({ status: 'rejected', reason }))
            )
        );
        };

    }
}